import React, { FunctionComponent } from "react";
import "./action-button-container.css";
import { Stack } from "@mui/material";

interface Props {
    class_name?: string,
    children: React.ReactNode
}

const ActionButtonContainer: FunctionComponent<Props> = (props) => {
    return (
        <Stack p={2} width={"100%"}>{props.children}</Stack>
    );
}

export default ActionButtonContainer;